import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'config/api';
import Prettyfier from 'components/Prettyfier';
import Template from 'components/Template';
import ScrollToTopOnMount from '../ScrollToTopOnMount';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

// import './Legal.css';

// import Immutable from 'immutable';

import { fetchData, getDataLegal, getLoadingError } from '../../ducks/asyncFetcher';

const AF_KEY = 'legal';
const styles = (theme) => {
  return {
    root: {},
    title: {
      fontSize: '2rem',
    },
  };
};
class Legal extends Component {
  // constructor(props) {
  //   super(props);
  // }
  componentDidMount() {
    this.props.onMount();
  }
  render() {
    const { $$data, classes } = this.props;

    const $$legal = $$data !== undefined ? $$data.get('legal').get(0).get('items').get(0) : undefined;

    return (
      <Template
        title={
          <Typography variant="h1" className={classes.title}>
            Politique de confidentialité et Protection des données personnelles
          </Typography>
        }
        offset={false}
      >
        <div className={classes.root}>
          <Choose>
            <When condition={$$legal !== undefined}>
              <ScrollToTopOnMount />
              <div className="legalWrapper">
                <div className="content">
                  <Prettyfier text={$$legal.get('content')} transformBullets={false} />
                </div>
              </div>
            </When>
            <Otherwise>
              <div>LOADING !!</div>
            </Otherwise>
          </Choose>
        </div>
      </Template>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataLegal(state),
    error: getLoadingError(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.legal }));
    },
  };
}
// export default Mission;
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Legal));



// WEBPACK FOOTER //
// ./src/components/Legal/Legal.jsx